import { NavLink, useNavigate } from "react-router-dom";
import styles from "./LeftMenu.module.scss";
import logo from "@src/shared/assets/logo_1.png";
import whatsappImg from "@src/shared/assets/whatsapp_img.svg";
import referenceImg from "@src/shared/assets/reference_img.svg";
import supportImg from "@src/shared/assets/letter_support_img.svg";
import ThumbUpAltOutlinedIcon from "@mui/icons-material/ThumbUpAltOutlined";
import ThumbDownOffAltIcon from "@mui/icons-material/ThumbDownOffAlt";
import { Button, IconButton } from "@mui/material";
import { useState } from "react";
import { useSendRating } from "@src/entities/rating";
import { useUserInfoMeStore } from "@src/entities/user/model/store/userInfoMeStore";
import { ReviewModal } from "@src/features/reviewPopover/ui/ReviewModal";

type ISelectedButton = "like" | "dislike" | "";

const LOCAL_STORAGE_RATING_KEY = "rating";
const defaultRating =
  (localStorage.getItem(LOCAL_STORAGE_RATING_KEY) as ISelectedButton) || "";

export const LeftMenu = () => {
  const [selected, setSelected] = useState<ISelectedButton>(defaultRating);
  const [open, setOpen] = useState<boolean>(false);
  const navigate = useNavigate();

  const { mutate: sendRating } = useSendRating();
  const userInfo = useUserInfoMeStore((state) => state.user);

  const handleRatingButton = (value: ISelectedButton) => () => {
    const selectedValue = selected === value ? "" : value;
    setSelected(selectedValue);
    localStorage.setItem(LOCAL_STORAGE_RATING_KEY, selectedValue);
    if (userInfo?.id && selectedValue) {
      const params = {
        user_id: userInfo.id,
        rating: selectedValue,
      };
      sendRating(params);
    }
  };

  const handleReviewButton = () => setOpen(true);

  const handleClosePopover = () => setOpen(false);

  return (
    <div className={styles.menu}>
      <div className={styles.logoWrapper} onClick={() => navigate("/")}>
        <img src={logo} alt="logo" className={styles.logo} />
      </div>
      <nav className={styles.nav}>
        <NavLink
          to="/docs/help.pdf"
          target="_blank"
          rel="noopener noreferrer"
          className={styles.navItem}
        >
          <img src={referenceImg} alt="инструкция по работе с сервисом" />
        </NavLink>
        <NavLink
          to="https://api.whatsapp.com/send/?phone=79300351166&text&type=phone_number&app_absent=0"
          className={styles.navItem}
        >
          <img src={whatsappImg} alt="переход на страницу whatsapp" />
        </NavLink>
        <NavLink
          to="mailto:support@naimus.ai?subject=Вопрос по сервису&body=Здравствуйте!"
          target="_blank"
          rel="noopener noreferrer"
          className={styles.navItem}
        >
          <img src={supportImg} alt="письмо в поддержку" />
        </NavLink>
      </nav>
      <div className={styles.additionalInfo}>
        <div className={styles.appLike}>
          <div className={styles.title}>
            <span>Оцените</span>
          </div>
          <div className={styles.btns}>
            <IconButton onClick={handleRatingButton("like")}>
              <ThumbUpAltOutlinedIcon
                className={`${styles.likeImg} ${
                  selected === "like" ? styles.active : ""
                }`}
              />
            </IconButton>
            <IconButton onClick={handleRatingButton("dislike")}>
              <ThumbDownOffAltIcon
                className={`${styles.dislikeImg} ${
                  selected === "dislike" ? styles.active : ""
                }`}
              />
            </IconButton>
          </div>
        </div>
        <Button className={styles.reviewBtn} onClick={handleReviewButton}>
          Оставить отзыв
        </Button>
      </div>
      <ReviewModal
        open={open}
        onClose={handleClosePopover}
        userId={userInfo?.id || null}
      />
    </div>
  );
};
